export type AgentProvider = 'anthropic' | 'openai' | 'bedrock_anthropic' | 'bedrock_openai';

export const AGENT_PROVIDERS: readonly AgentProvider[] = ['anthropic', 'openai', 'bedrock_anthropic', 'bedrock_openai'];

export const DEFAULT_PROVIDER: AgentProvider = 'anthropic';

export interface AgentModelOption {
    id: string;
    label: string;
    short_label: string;
    provider: AgentProvider;
}
